import { Grid2 as Grid, Stack } from '@mui/material';
import { TextInput, TextArea, useFormContext, DateInput } from 'framework/form';
import DeleteCriticalPeriodModal from './DeleteCriticalPeriodModal';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useState } from 'react';
import { Button } from 'framework/ui/mui-builder';

interface CriticalPeriodFormProps {
  isUpdateForm?: boolean;
  isSystemPeriod?: boolean;
  canDelete?: boolean;
}

const CriticalPeriodForm = ({ isUpdateForm, isSystemPeriod, canDelete }: CriticalPeriodFormProps) => {
  const { id } = useParams();
  const { data, submitForm, isSubmitEnabled } = useFormContext();
  const navigate = useNavigate();
  const [length] = useState(navigate.length - 1);

  return (
    <Stack spacing={2} py={2}>
      <Grid container spacing={2}>
        <Grid size={6}>
          <TextInput disabled={isSystemPeriod} source="title" label="Name" />
        </Grid>
        <Grid size={3}>
          <DateInput source="startDate" label="Start" />
        </Grid>
        <Grid size={3}>
          <DateInput source="endDate" label="End" />
        </Grid>
      </Grid>

      <Grid size={12}>
        <TextArea rows={5} source="description" label="Note" />
      </Grid>
      <Grid container direction="row" justifyContent="flex-end" gap={1}>
        {isUpdateForm && <DeleteCriticalPeriodModal canDelete={canDelete} projectId={id!} id={data?.id} />}
        <Grid container gap={1}>
          <Button variant="outlined" onClick={() => navigate(length - navigate.length)}>
            Cancel
          </Button>
          <Button variant="contained" disabled={!isSubmitEnabled} onClick={() => (submitForm ? submitForm() : null)}>
            Submit
          </Button>
        </Grid>
      </Grid>
    </Stack>
  );
};
export default CriticalPeriodForm;
